/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import Vue from 'vue';
import App from './App/index.vue';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import Meta from 'vue-meta';
import '@/validators';
import '@/plugins';
import '@/filters';
import '@/services/gtm';
import './registerServiceWorker';

/**
 * Main entry point for vue application.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

Vue.config.productionTip = false;

// configure translations
i18n(store);

Vue.use(Meta);

new Vue({
    router,
    store,
    // tslint:disable-next-line
    render: (h) => h(App),
}).$mount('#app');
